import ToeicForm from "../../components/ToeicForm";
function ToeicFormPage() {
  return (
    <div>
      <ToeicForm />
    </div>
  );
}

export default ToeicFormPage;
